import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { Subscription } from 'rxjs';

import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { TranslationService } from './modules/i18n';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { ConfigurationService } from './core/services/configuration.service';
import { environment } from 'src/environments/environment';

// language list
@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  readonly maintenance = environment.maintenance;
  private unsubscribe: Subscription[] = [];

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private router: Router,
    private splashScreenService: SplashScreenService,
    private titleService: Title,
    private localeService: BsLocaleService,
    private ngSelectConfig: NgSelectConfig,
    private configurationService: ConfigurationService
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );

    this.ngSelectConfig.notFoundText = 'Nenhum item encontrado';
    this.ngSelectConfig.loadingText = 'Carregando...';
  }

  ngOnInit() {
    if (this.maintenance) {
      this.titleService.setTitle('Sistema em manutenção');
      return;
    }

    this.localeService.use('pt-br');
    this.modeService.init();

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scroll(0, 0);

        setTimeout(() => {
          //document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });

    this.unsubscribe.push(routerSubscription);

    this.unsubscribe.push(
      this.configurationService.companySubject.subscribe((c) => {
        if (c) {
          this.titleService.setTitle(c.companyName);
          this.setFavicon(c.favicon?.contentUrl);

          if(environment?.['staging']){
            this.setFavicon('./assets/media/logos/staging-favico.jpg');
          }
        }
      })
    );
  }

  private setFavicon(faviconUrl: string | undefined): void {
    if (faviconUrl) {
      const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.href = faviconUrl;
      document.head.appendChild(link);
    }
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
